<template>
  <div class="select-card-wrapper">
    <div
      class="select-card"
      @click="handleCardSelect"
      :class="{
        cardSend: selectedAction === 'send',
        cardReturn: selectedAction === 'return',
        cardMarket: selectedAction === 'market',
        none: selectedAction === 'none',
        disabled: isHistory,
      }">
      <div class="image-area">
        <img
          class="card"
          :class="{'radius': cardTypeRadius}"
          :src="acquiredCardItem.image"
          :alt="acquiredCardItem.name"
        >
        <div v-if="acquiredCardItem.title" class="card-title">{{acquiredCardItem.title}}</div>
        <div class="chkblock">
          <img
            v-if="selectedAction === 'send'"
            src="/img/plane.png"
          >
          <img
            v-if="selectedAction === 'return'"
            src="/img/star_coin.webp"
          >
          <img
            v-if="selectedAction === 'market'"
            src="/img/market.png"
          >
        </div>
      </div>
      <div class="card-content">
        <div class="card-info">
          <div v-if="acquiredCardItem.shipping_schedule" class="shipping_schedule">
            {{ acquiredCardItem.shipping_schedule }}
          </div>
          <span v-if="Number(acquiredCardItem.num) > 1" class="num">
            <span>{{ formatNum }}</span>
          </span>
          <img v-if="acquiredCardItem.name && acquiredCardItem.name.includes('PSA')" class="psa-icon" src="/img/PSA.png">
          <div class="name">
            {{ acquiredCardItem.name }}
          </div>
          <div class="rarity">
            {{ acquiredCardItem.rarity_label }}
          </div>
          <div class="rarity">
            {{ acquiredCardItem.model_number }}
          </div>
        </div>
        <div class="point_area">
          <span v-if="acquiredCardItem.action_type === '2'" class="only_ship">
            <span class="only_ship_text">
              <img
              src="/img/plane.png"
              class="ship-icon"
              >
              {{ t('発送のみ') }}
            </span>
            {{ t('発送') }}
          </span>
          <span v-if="acquiredCardItem.action_type === '1'" class="card_point">
            <span class="only_return">
              <img
                src="/img/star_coin.webp"
                class="coin-icon"
                >
              {{ t('Coinのみ') }}
            </span>
            <img
                src="/img/star_coin.webp"
              >
            {{ acquiredCardItem.buy_point | comma }}Coin
          </span>
          <span v-if="acquiredCardItem.action_type === '3'" class="only_market">{{ t('マーケットへ出品') }}</span>
          <div v-if="acquiredCardItem.action_type === '0' || acquiredCardItem.action_type === '4'">
            <span v-if="selectedAction == 'return'" class="card_point">
              <img
                src="/img/star_coin.webp"
              >
              {{ acquiredCardItem.buy_point | comma }}Coin</span>
            <span v-if="selectedAction === 'send'">{{ t('発送') }}</span>
            <span v-if="selectedAction === 'market' && acquiredCardItem.action_type === '0'">
              {{ t('Xmarketへ出品') }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="market-price-info" :class="{ 'japanese': currentUser && currentUser.language === 'ja' }">
      <span v-if="currentUser.rank == 1 || parseInt(currentPack.point, 10) > parseInt(acquiredCardItem.buy_point, 10) || isMarketDisabled">
        {{ t('出品対象外品') }}
      </span>
      <span v-if="selectedAction === 'market' && acquiredCardItem.min_price">
        {{ formatPriceMessage(acquiredCardItem.min_price) }}
      </span>
    </div>
  </div>
</template>

<script>
import { separateCharacterNumber } from '@/common/util/format';
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';

export default {
  name: 'SelectCard',
  mixins: [t],

  props: {
    acquiredCardItem: {
      type: Object,
    },
    selectedAction: {
      type: String,
      default: '',
    },
    isHistory: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      default: '',
    },
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
  },

  mounted() {
    // action_typeに応じて初期アクションを固定化
    if (this.acquiredCardItem.action_type === '1') {
      this.selectedAction = 'send';
    } else if (this.acquiredCardItem.action_type === '2') {
      this.selectedAction = 'return';
    } else if (this.acquiredCardItem.action_type === '3') {
      this.selectedAction = 'market';
    } else {
      this.selectedAction = 'none';
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
    }),
    cardTypeRadius() {
      const isSpecialType = ['2', '3', '5'].includes(String(this.cardType));
      const isBox = this.acquiredCardItem && this.acquiredCardItem.name && this.acquiredCardItem.name.includes('BOX');
      return isSpecialType && !isBox;
    },
    formatNum() {
      const num = Number(this.acquiredCardItem.num);
      if (!num) return null;
      const lang = (this.currentUser && this.currentUser.language) || 'ja';
      const key = '{num}枚セット';
      const template = (this.i18n_message && this.i18n_message[key] && this.i18n_message[key][lang]) || key;
      return template.replace('{num}', num);
    },
    isMarketDisabled() {
      return this.acquiredCardItem.action_type === '4' || (this.currentPack && this.currentPack.market_enabled === '0');
    },
  },

  methods: {
    formatPriceMessage(min) {
      if (!min) return null;
      const lang = (this.currentUser && this.currentUser.language) || 'ja';
      const key = '{min}円以上の価格で出品できます';
      const template = (this.i18n_message && this.i18n_message[key] && this.i18n_message[key][lang]) || key;
      const formattedMessage = template.replace('{min}', separateCharacterNumber(min));
      // 日本語の場合「出品できます」を2行目にする
      if (lang === 'ja') {
        return formattedMessage.replace('出品できます', '\n出品できます');
      }
      return formattedMessage;
    },
    handleCardSelect() {
      if (this.acquiredCardItem.action_type === '1' || this.acquiredCardItem.action_type === '2') {
        return;
      }
      let nextAction = '';
      switch (this.selectedAction) {
        case 'send':
          if (this.currentUser.rank === 1 || parseInt(this.currentPack.point, 10) > parseInt(this.acquiredCardItem.buy_point, 10) || this.isMarketDisabled) {
            nextAction = 'return';
          } else {
            nextAction = 'market';
          }
          break;
        case 'market':
          nextAction = 'return';
          break;
        case 'return':
          nextAction = 'send';
          break;
        default:
          nextAction = 'send';
          break;
      }
      this.$emit('handleCardSelect', this.acquiredCardItem.history_id, this.acquiredCardItem.action_type, nextAction);
    },
  },
};
</script>

<style lang="scss" scoped>
.select-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center; // カードの中央寄せを保持
  width: 200px;
  .market-price-info {
    margin: 2px auto 0 auto;
    color: #ff0000;
    font-size: 16px;
    font-weight: normal;
    line-height: 1.1;
    text-align: center;
    min-height: 20px;
    width: 100%;
    align-self: center;
    white-space: pre-wrap;
    &.japanese {
      white-space: pre;
    }
  }
}
.select-card{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 30px 30px 10px;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.7);
  cursor: pointer;
  &.disabled {
    cursor: default; // isHistory が true の場合
    pointer-events: none; // 完全にクリックを無効化（オプション）
  }
  .image-area {
    // position: relative;
    .card-title{
      position: absolute;
      top: -15px; // カードより上に
      right: 0;
      background-color: #fff;
      padding: 2px 6px;
      font-size: 17px;
      border-radius: 5px;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
      color: #12469b;
      z-index: 2;
    }
    .chkblock {
      position: absolute;
      top: -30px;
      left: -30px;
      img {
        width: 70px;
      }
    }
  }
  .card{
    width: 100%;
    min-width: 113px;
    // 右に少し傾ける
    transform: rotate(10deg);
    &.radius{
      border-radius: 5px;
    }
  }
  .card-content{
    width: 125%;
    .card-info{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: $gray2;
      font-weight: bold;
      background: $white;
      z-index: 1;
      margin-top: -35px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.7);
      border-radius: 10px;
      position: relative;
      padding: 4px;
      .shipping_schedule{
        position: absolute;
        bottom: 100%;
        right: 0;
        margin-bottom: 3px;
        border-radius: 5px;
        padding: 1px 4px;
        background-color: #fff;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.3);
        margin-bottom: 6px;
        color: #cd151d;
      }
      .num{
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.7);
        position: absolute;
        padding: 1px 4px;
        top: -34px;
        right: 0;
        font-size: 20px;
        font-weight: bold;
        color: #0614c3;;
      }
      .psa-icon{
        position: absolute;
        top: -38px;
        left: -5px;
        width: 70px;
        height: auto;
      }
      .name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
        line-height: 1.2;
        max-height: calc(1.3em * 2); // 2行分の高さ
        text-align: center;
        white-space: normal;
        // padding: 2px 1px;
      }
      .rarity {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
        white-space: normal;
        font-size: 12px;
      }
    }
  }
  .point_area {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    font-size: 20px;
    color: #646464;
    font-weight: bold;
    .only_market {
      font-size: 17px;
    }
    .point {
      font-size: 20px;
      font-weight: 700;
      margin-left: 5px;
      position: relative;
      &:after {
        content: "Gem";
      }
    }
    .card_point {
      padding-right: 13px;
      display: flex;
      align-items: center;
      img {
        width: 40px;
      }
    }
    .only_return{
      position: absolute;
      top: -19px;
      right: -2px;
      background-color: #fff;
      color: #6f6e6f;
      font-weight: bold;
      font-size: 18px;
      padding: 8px 5px 8px 45px;
      border-radius: 3px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
      border: 1px solid #afafaf;
      white-space: nowrap;
      .coin-icon {
        width: 47px;
        position: absolute;
        left: -1px;
        top: 3px;
      }
    }
    .only_ship_text{
      position: absolute;
      top: -19px;
      right: -2px;
      background-color: #fff;
      color: #6f6e6f;
      font-weight: bold;
      font-size: 18px;
      padding: 8px 5px 8px 45px;
      border-radius: 3px;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.3);
      border: 1px solid #afafaf;
      white-space: nowrap;
      .ship-icon {
        width: 47px;
        position: absolute;
        left: 0;
        top: -1px;
      }
    }
  }
}
.cardReturn {
  border: 2px solid transparent;
}
.cardSend {
  background-image:
    linear-gradient(white, white),
    linear-gradient(to right, #4ea8de, #0d1f40);
  background-clip: padding-box, border-box;
  background-origin: border-box;
  border: 2px solid transparent;
}
.cardMarket {
  background-image:
    linear-gradient(white, white),
    linear-gradient(to right, yellow, orange, red);
  background-clip: padding-box, border-box;
  background-origin: border-box;
  border: 2px solid transparent;
}
@media screen and  (max-width: $tabletWidth) {
  .select-card-wrapper {
    width: 130px;
    .market-price-info {
      font-size: 11px;
      min-height: 25px;
    }
  }
  .select-card {
    margin-top: 5px;
    padding: 10px;
    min-height: 180px;
    .card{
      width: 70px;
      min-width: 70px;
    }
    .card-content{
      width: 110%;
      .card-info{
        .shipping_schedule{
          font-size: 7px;
          padding: 1px 4px;
          margin-bottom: 2px;
        }
        .num{
          top: -18px;
          font-size: 10px;

        }
        .psa-icon{
          width: 40px;
          top: -22px;
        }
        .name{
          font-size: 9px;
        }
        .rarity {
          font-size: 9px;
        }
      }
      .point_area {
        margin-left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        .only_market {
          font-size: 12px;
        }

        .only_return{
          top: -15px;
          font-size: 11px;
          padding: 4px 2px 4px 29px;
          .coin-icon {
            width: 31px;
            left: 0px;
            top: 0px;
          }
        }
        .only_ship_text{
          top: -15px;
          font-size: 11px;
          padding: 4px 2px 4px 29px;
          .ship-icon {
            width: 29px;
            top: -3px;
          }
        }
        .card_point {
          padding-right: 6px;
          img {
            width: 25px;
          }
        }
      }
    }
    .image-area {
      .card-title{
        top: -10px;
        font-size: 9px;
        padding: 1px 4px;
      }
      .chkblock {
        top: -15px;
        left: -20px;
        img {
          width: 45px;
        }
      }
    }
  }
}
</style>
